import AppCatalog from "../../services/App/AppCatalog.js";
import AppModule from "../../services/App/AppModule.js";

export default {
  Modal: {
    SearchList: {
      Label: AppCatalog.Field.Search.Label + " " + AppModule.Stock.FullName
    }
  }
}